import { createGlobalStyle } from 'styled-components';
import Poppins300 from 'assets/fonts/poppins/poppins-300.woff2';
import Poppins400 from 'assets/fonts/poppins/poppins-400.woff2';
import Poppins500 from 'assets/fonts/poppins/poppins-500.woff2';
import Poppins700 from 'assets/fonts/poppins/poppins-700.woff2';

/**
 * Poppins servida pelo próprio app. O @import do Google Fonts dentro de um
 * styled-component só é aplicado pelo navegador quando cai no topo da folha de
 * estilos, o que não dá para garantir; @font-face vale em qualquer posição.
 *
 * O nome da família é próprio de propósito: registrar "Poppins" trocaria a
 * fonte das telas antigas que declaram essa família e hoje caem no fallback.
 */
export const POPPINS_FAMILY = "'Poppins Local', 'Roboto', sans-serif";

const PoppinsFont = createGlobalStyle`
  @font-face {
    font-family: 'Poppins Local';
    font-style: normal;
    font-weight: 300;
    font-display: swap;
    src: url(${Poppins300}) format('woff2');
  }

  @font-face {
    font-family: 'Poppins Local';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url(${Poppins400}) format('woff2');
  }

  @font-face {
    font-family: 'Poppins Local';
    font-style: normal;
    font-weight: 500;
    font-display: swap;
    src: url(${Poppins500}) format('woff2');
  }

  @font-face {
    font-family: 'Poppins Local';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url(${Poppins700}) format('woff2');
  }
`;

export default PoppinsFont;
